import {ORGANIZATION_ID} from "../../const";
import {getPublicApiBaseUrl} from "../../helpers/apiBaseUrl";

/** Öffentliche Adresse eines hochgeladenen Bildes. In der Entwicklung proxyt der Dev-Server `/api`. */
export const contentImageUrl = (id: string): string => `${getPublicApiBaseUrl() || window.location.origin}/api/public/content-image/${id}`;

/**
 * Lädt ein Bild per GraphQL-Multipart hoch (kein `createUploadLink` im Apollo-Setup,
 * Vorbild: UploadBadgeGraphic) und liefert die öffentliche URL. Wirft mit lesbarer Meldung.
 */
export const uploadContentImage = async (uri: string, file: File, fallbackError: string): Promise<string> => {
    const formData = new FormData();

    formData.append(
        "operations",
        JSON.stringify({
            query: "mutation uploadContentImage($file: Upload!) { uploadContentImage(file: $file) { id } }",
            variables: {file: null},
        }),
    );
    formData.append("map", JSON.stringify({"0": ["variables.file"]}));
    formData.append("0", file);

    const response = await fetch(uri, {
        method: "POST",
        body: formData,
        headers: {"x-ko-organization-id": ORGANIZATION_ID},
        credentials: "include",
    });

    if (!response.ok) {
        throw new Error(fallbackError);
    }

    const data: {data?: {uploadContentImage?: {id: string}}; errors?: Array<{message: string}>} = await response.json().catch(() => ({}));

    if (data.errors && data.errors.length > 0) {
        throw new Error(data.errors[0].message);
    }
    if (!data.data || !data.data.uploadContentImage) {
        throw new Error(fallbackError);
    }

    return contentImageUrl(data.data.uploadContentImage.id);
};
